/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "mse-tool-components/src/vendor/modernizr"

import { mseGTM } from "mse-tools-masthead-and-footer/lib/mse-gtm"

if (typeof window !== "undefined") {
  mseGTM({ exclude: ["contentsquare"] })
}
